<template>
  <div class="salaries-footer">
    <div class="salaries-footer__back">
      <img
        loading="lazy"
        class="salaries-footer__back-img-mobile"
        src="./images/bg-pins-mobile.png"
        srcset="./images/bg-pins-mobile.png, ./images/bg-pins-mobile@2x.png 2x"
      />
      <img
        loading="lazy"
        class="salaries-footer__back-img-desktop"
        src="./images/bg-pins-desktop.png"
        srcset="./images/bg-pins-desktop.png, ./images/bg-pins-desktop@2x.png 2x"
      />
    </div>
    <div class="salaries-footer__wrapper">
      <BravadoText class="salaries-footer__header" tag="h2" variant="header1">
        Bravado Employers pay 30% above market rate. Interested in getting paid more?
      </BravadoText>
      <BravadoText class="salaries-footer__headline" tag="p" variant="headline">
        All Bravado Employers are vetted to ensure they are a great place to work and offer competitive compensation.
        Whether you're actively looking for a new role or passively curious, the sales talent market has never been
        hotter.
      </BravadoText>
      <BravadoButtonV3 :to="'/jobs'" class="salaries-footer__cta" variant="accent">Open Roles</BravadoButtonV3>

      <BravadoText class="salaries-footer__methodology" tag="h3" variant="header3">About Bravado</BravadoText>
      <BravadoText class="salaries-footer__methodology-headline" tag="p" variant="headline">
        Bravado is the most important platform for sales professionals to be successful in their careers. Over 150,000+
        B2B sales professionals trust Bravado to improve their performance, level up their sales skills, network with
        peers, build trust with customers and find the right job. Our members hail from over 11,000+ sales teams from 82
        countries worldwide. Top sellers from Google, Salesforce, Facebook, and Amazon level up their careers on
        Bravado.
      </BravadoText>

      <BravadoButtonV3 :to="learnAboutBravadoUrlPage" class="salaries-footer__cta" variant="accent">
        Learn more about Bravado
      </BravadoButtonV3>

      <img loading="lazy" src="./images/logos.png" alt="map" class="salaries-footer__logos" />
    </div>

    <template v-for="{ id, zoom, blur, top, left, val } in tooltips">
      <SalariesTooltip :key="id" :top="top" :left="left" :blur="blur" :zoom="zoom">${{ val }}k</SalariesTooltip>
    </template>
  </div>
</template>

<script>
import SalariesTooltip from './SalariesTooltip';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';
import { WAR_ROOM_POSTS_TAB_MYFEED_PAGE } from '~/constants';
import { isWarRoomUser } from '~/components/partials/war-room/utils';

export default {
  name: 'SalariesFooter',
  components: { BravadoText, SalariesTooltip, BravadoButtonV3 },
  computed: {
    tooltips() {
      return [];
    },
    learnAboutBravadoUrlPage() {
      if (!this.$auth.loggedIn || !isWarRoomUser(this.$auth.user)) {
        window.location.href = `/b2c/?${new URLSearchParams(this.$route.query).toString()}`;
        return;
      }

      return WAR_ROOM_POSTS_TAB_MYFEED_PAGE;
    },
  },
};
</script>
<style lang="scss" scoped>
.salaries-footer {
  background: #161a21;
  height: 1614px;
  width: 100%;
  position: relative;

  &__back {
    position: absolute;
    left: 0;
    right: 0;
  }

  &__back-img-desktop {
    display: none;
    width: 100%;
    height: auto;

    @include mq('sm') {
      display: block;
    }
  }

  &__back-img-mobile {
    display: block;
    width: 100%;
    height: auto;

    @include mq('sm') {
      display: none;
    }
  }

  &__wrapper {
    margin: 0 auto;
    max-width: 1000px;
    width: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
  }

  &__header {
    color: #fff;
    margin-top: 130px;
    text-align: center;
    padding: 0 50px;
    font-size: 28px;
    line-height: 32px;

    @include mq('sm') {
      font-size: 49px;
      line-height: 60px;
      padding: 0 100px;
    }
  }

  &__headline {
    font-size: 20px;
    margin-top: 20px;
    line-height: 1.5;
    color: #afb7bf;
    text-align: center;
    padding: 0 50px;

    @include mq('sm') {
      padding: 0 100px;
    }
  }

  &__cta {
    margin: 25px auto;
    display: inline-flex;
    left: 50%;
    transform: translateX(-50%);
  }

  &__methodology {
    padding: 90px 50px 0;
    margin-bottom: 16px;
    color: #fff;

    @include mq('sm') {
      padding: 90px 100px 0;
    }
  }

  &__methodology-headline {
    padding: 0 50px;
    color: #afb7bf;

    @include mq('sm') {
      padding: 0 100px;
    }
  }

  &__map {
    position: absolute;
    left: 0;
    bottom: 100px;
    width: 100%;
    z-index: 2;
  }

  &__shadow {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 1;
  }

  &__shadow-top {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }

  &__logos {
    width: 100%;
    margin-top: 100px;
  }
}
</style>
